import DOMPurify from 'dompurify';
import { t } from '../../../i18n/i18n';
import { parseLineHTML } from '../../../utils/parseLineHTML';

const OptionText = ({ submission }) => {
  const textWithLineBreaks = DOMPurify.sanitize(parseLineHTML(submission?.submittedText || ''));
  return (
    <>
      <span className=" font-weight-600 text-xs text-color-item-test-group mt-2">
        {t('MODAL_ANSWER')}
      </span>
      <div className="d-inline p-2 mt-2 w-100 modal-container-text-custom">
        <span
          className=" text-xs text-black text-break"
          dangerouslySetInnerHTML={{ __html: textWithLineBreaks }}
        />
      </div>
    </>
  );
};

export default OptionText;
